export default {
  'active': true,
  'createdAt': '',
  'createdBy': '',
  'description': '',
  'draft': true,
  'facebookPixelId': '',
  'id': '',
  'assets': [],
  'modifiedAt': '',
  'modifiedBy': '',
  'playerName': '',
  'playerType': 'attach-web',
  'privacyPolicyLink': '',
  'products': [],
  'termsAndConditions': '',
  'tracking': '',
  'trackingPixel': '',
  'trackingRaw': '',
  'version': '2.0',
  'videos': [],
};
